import axios from "axios";
import { getHeader, getToken } from "@/helpers/functions";

const header = getHeader(getToken("ifragasatt_cookie"));

const state = {
  aliasIsBlocked: false,
  myAlias: {}
};

const getters = {
  myAlias: state => state.myAlias,
  hasAlias: state => !!Object.keys(state.myAlias).length && state.myAlias.id !== 0,
  aliasIsBlocked: state => state.aliasIsBlocked
};

const mutations = {
  setMyAlias: (state, payload) => {
    console.log("set alias: ", payload);
    state.myAlias = payload;
  },
  updateMyAlias: (state, payload) => {
    state.myAlias.description = payload.description;
    state.myAlias.imageRotation = payload.imageRotation;
    state.myAlias.profilePicture = payload.profilePicture;
  }
};

const actions = {
  setMyAlias({ commit }, payload) {
    commit("setMyAlias", payload);
  },
  getMyAlias({ commit, dispatch }) {
    const url = `${process.env.VUE_APP_MY_PROFILE}/?isalias=true`;
    dispatch("setIsLoading", true);

    axios
      .get(url, header)
      .then(res => {
        commit("setMyAlias", {
          id: res.data.id,
          createdAt: res.data.createdAt,
          description: res.data.description,
          imageRotation: res.data.imageRotation,
          name: res.data.name,
          profilePicture: res.data.profilePicture,
          slug: res.data.slug,
          numComments: res.data.numComments,
          numRemoved: res.data.numRemovedComments
        });
      })
      .catch(err => {
        console.error(err);
        dispatch("showToast", { message: "errors.ALIAS_FETCH_FAILED", type: "error" });
      })
      .finally(() => dispatch("setIsLoading", false));
  },
  updateAlias({ commit, dispatch }, payload) {
    const url = `${process.env.VUE_APP_MY_ALIAS}`;
    dispatch("setIsLoading", true);

    axios
      .put(url, payload, header)
      .then(res => {
        commit("updateMyAlias", res.data);
      })
      .catch(err => console.log(err))
      .finally(() => dispatch("setIsLoading", false));
  },
  createAlias({ commit, dispatch }, payload) {
    const url = `${process.env.VUE_APP_MY_ALIAS}`;
    dispatch("setIsLoading", true);

    axios
      .post(url, payload, header)
      .then(res => {
        commit("setMyAlias", {
          id: res.data.id,
          createdAt: res.data.createdAt,
          description: res.data.description,
          imageRotation: res.data.imageRotation,
          name: res.data.name,
          profilePicture: res.data.profilePicture,
          numComments: res.data.numComments,
          numRemoved: res.data.numRemovedComments
        });
      })
      .catch(err => {
        console.error(err);
        if (err.response.status == 409)
          dispatch("showToast", { message: "errors.ALIAS_ALREADY_TAKEN", type: "error" });
        else dispatch("showToast", { message: "errors.ALIAS_CREATE_FAILED", type: "error" });
      })
      .finally(() => dispatch("setIsLoading", false));
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
